var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4031 12.4031C13.0587 11.7474 13.5788 10.9691 13.9336 10.1125C14.2884 9.25586 14.471 8.33775 14.471 7.41056C14.471 6.48337 14.2884 5.56525 13.9336 4.70864C13.5788 3.85202 13.0587 3.07368 12.4031 2.41806C11.7474 1.76243 10.9691 1.24236 10.1125 0.887543C9.25587 0.532722 8.33775 0.350098 7.41056 0.350098C6.48337 0.350098 5.56525 0.532722 4.70864 0.887543C3.85202 1.24236 3.07368 1.76243 2.41806 2.41806C1.09397 3.74215 0.350098 5.53801 0.350098 7.41056C0.350098 9.28311 1.09397 11.079 2.41806 12.4031C3.74215 13.7272 5.53801 14.471 7.41056 14.471C9.28311 14.471 11.079 13.7272 12.4031 12.4031ZM12.4031 12.4031L16.8501 16.8501",
    stroke: "#E6E6E6",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.b975b41130aae05419b8097420dc4886.svg";
export { ForwardRef as ReactComponent };